import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { loginRequest } from '../../../authConfig'
import LangSelector from '../../utils/LangSelector'
import { GraphData } from '../../../models/GraphData'
import { useAppDispatch } from '../../../utils/hooks'
import { useMsal, useMsalAuthentication } from '@azure/msal-react'
import { BrowserUtils, InteractionType } from '@azure/msal-browser'
import { Avatar, Dropdown, MenuProps, Space, Typography } from 'antd'
import { callMsGraphTokenUserInfos } from '../../../utils/MsGraphApiCall'
import { selectLoggedUser, setLoggedUser } from '../../../reducers/UserReducer'

const { Text } = Typography

const RightHeader = () => {
  const intl = useIntl()
  const dispatch = useAppDispatch()

  const { instance } = useMsal()
  const { result, error } = useMsalAuthentication(
    InteractionType.Redirect,
    loginRequest
  )

  const user = useSelector(selectLoggedUser)
  const [graphData, setGraphData] = useState<GraphData | undefined>(undefined)

  const items: MenuProps['items'] = [
    {
      key: 2,
      label: <Text>{intl.formatMessage({ id: 'LOGOUT' })}</Text>,
      onClick: () =>
        instance.logoutRedirect({
          account: instance.getActiveAccount(),
          onRedirectNavigate: () => !BrowserUtils.isInIframe(),
        }),
    },
  ]

  useEffect(() => {
    if (!!graphData) {
      // We already have the data, no need to call the API
      return
    }

    if (!!error) {
      // Error occurred attempting to acquire a token, either handle the error or do nothing
      return
    }

    if (result) {
      callMsGraphTokenUserInfos().then((response) => {
        setGraphData(response)
        dispatch(
          setLoggedUser({
            id: response.id,
            firstName: response.givenName,
            lastName: response.surname,
            email: response.mail,
          })
        )
      })
    }
  }, [error, result, graphData])

  return (
    <Space>
      <Dropdown menu={{ items }} placement="bottomLeft" arrow>
        <Avatar
          style={{
            color: '#fff',
            backgroundColor: '#6c7cff',
            cursor: 'pointer',
          }}
        >
          {user && user.firstName && user.lastName
            ? user!.firstName.slice(0, 1) + user!.lastName.slice(0, 1)
            : '--'}
        </Avatar>
      </Dropdown>
    </Space>
  )
}

export default RightHeader
